import { isoToDateString, monthEnding } from "utils/date";

export default [

  { field: 'license', width: 150, headerAlign: 'center', headerName: 'Лицензия' },

  { field: 'duration', width: 100, headerAlign: 'center', headerName: 'Длительность', align: 'center', 
    valueGetter: (value) => `${value} ${monthEnding(value)}` },

  { field: 'licenseEndAt', headerAlign: 'center', headerName: 'Действует до', width: 120, align: 'center',
    valueGetter: (value) => value ? isoToDateString(value) : 'не активирована' },
    
  { field: 'endActivationAt', headerAlign: 'center', headerName: 'Активация до', width: 120, align: 'center',
    valueGetter: (value) => value ? isoToDateString(value) : 'активирована' },
    
  { field: 'status', flex: 1, headerAlign: 'center', headerName: 'Статус', align: 'right' }

];